/**
 * Identificativi delle pagine
 */
export const PAGE_ID = {

    //#region FARMS

    UNKNOW: "unknow",
    LANDINGPAGE: "landing-page",

    FARMS: "farms",
    FARM_SETUP: "farm-setup",
    FARM_GROWUNITS: "growunits",
    FARM_PLANNER: "farm-gantt",
    FARM_CYCLES: "farm-cycles",
    FARM_TASKS: "farm-tasks",
    FARM_AI_PLANNING: "farm-ai-planning",
    FARM_ALERTS: "farm-alerts",
    FARM_PLC_ALERTS: "farm-plc-alert",
    FARM_BI: "farm-bi",
    FARM_MAP: "farm-map",
    FARM_ATTACH: "farm-attach",
    
    FARM_CHARTS: "farm-main",
    FARM_CONSOLES: "farm-consoles",
    FARM_TECHNICAL_DASHBOARDS: "farm-technical-dashboards",
    FARM_BUSINESS_DASHBOARDS: "farm-business-dashboards",
    FARM_EXTERNAL_LINK: "farm-external-link",

    GROWUNIT_DETAIL: "growunits-detail",
    GROWUNIT_RECIPE: "growunits-recipe",
    GROWUNIT_TOWERS: "growunits-towers",
    GROWUNIT_PROPERTIES: "growunits-properties",

    //#endregion



    //#region PLC

    FARM_COMPONENTS: "farm-components",

    GROWUNIT_HOME: "growunit-home",
	GROWUNIT_MAIN: "growunit-main",
	GROWUNIT_LAYERS: "growunits-layers",
	GROWUNIT_FERTI: "growunits-ferti",
	GROWUNIT_ADJ: "growunits-adj",
	GROWUNIT_LIGHTING: "growunits-lighting",
	GROWUNIT_LIGHTING_PS: "growunits-lighting-ps",
    GROWUNIT_CLIMATE: "growunits-climate",
	GROWUNIT_IRRIGATION: "growunits-irrigation",
    GROWUNIT_PLC_ALERTS: "growunit-alerts",
    GROWUNIT_PLC_PROPERTIES: "growunit-plc-properties",

    COMPONENT_SCHEDULER : "component-scheduler",

    COMPONENT_HVAC: "component-hvac",
    COMPONENT_HVAC_ALERTS: "component-hvac-alerts",
    COMPONENT_HVAC_PROPERTIES: "component-hvac-properties",

    COMPONENT_OSMOTIC_WATER: "component-ow",
    COMPONENT_OSMOTIC_WATER_ALERTS: "component-ow-alerts",
    COMPONENT_OSMOTIC_WATER_PROPERTIES: "component-ow-properties",

	COMPONENT_GERMINATION: "component-germinator",
    COMPONENT_GERMINATION_ALERTS: "component-germinator-alerts",
    COMPONENT_GERMINATION_PROPERTIES: "component-germinator-properties",

    COMPONENT_CO2: "component-co2",
    COMPONENT_CO2_PANEL: "component-co2-panel",
    COMPONENT_CO2_ALERTS: "component-co2-alerts",
    COMPONENT_CO2_PROPERTIES: "component-co2-properties",

    COMPONENT_WATER_TREATMENT: "component-water-treatment",
    COMPONENT_WATER_TREATMENT_ALERTS: "component-water-treatment-alerts",
    COMPONENT_WATER_TREATMENT_PROPERTIES: "component-water-treatment-properties",

    COMPONENT_THERMAL_POWER_PLANT: "component-thermal-power-plant",

    COMPONENT_POWER_MONITOR: "component-power-monitor",

    FARM_MODULES: "modules",
    FARM_METADATA: "metadata",
    
    //#endregion



    //#region LIBRARY

    LIBRARY: "library",
    
    RECIPES: "recipes",
    RECIPES_DETAIL: "recipes-edit",

    CROPS: "crops",
    CROPS_DETAIL: "crops-edit",

    CROPS_RECIPES: "crops-recipes",
    CROPS_RECIPES_DETAIL: "crops-recipes-edit",

    PRODUCTS: "products",
    PRODUCTS_DETAIL: "products-edit",

    //#endregion


    
    //#region SETTINGS

    SETTINGS: "settings",

    ALARMS: "alarms",
    ALARMS_DETAIL: "alarms-edit",
    
    ROOT: "dashboard",
    ZW: "zw",
    PREFERENCES: "preferences",

    //#endregion
    
    
    //#region LABS

    LABS: "labs",
    LABS_SOLUTIONS: "labs-solutions",
    LABS_PLANNER: "labs-planner",
    LABS_GPT: "labs-gpt",

    //#endregion

}
export type PAGE_ID = typeof PAGE_ID | string

export enum URL_PAR {

    //#region GENERIC FILTER

	/** filtro testuale */
	TEXT = "search",
    /** nome del campo da applicare al SORT */
    SORT_NAME = "sortName",
    /** [true/false] se il SORT è DISCENDENTE o no */
    SORT_DES = "isDes",
    /** nome del tab selezionato. E' un TAB interno alla pagina  */
    TAB_SEL = "tab",
    
    /** DATE RANGE selezionata */
	DATE_SEL = "date.sel",

    /** PHASE NAME selezionata */
    PHASE_SEL = "phase.sel",
	/** la GROWUNIT attualmente SELEZIONATA */
	GROWUNIT_SEL = "gu.sel",
    /** MILTI SELEZIONE TOWERS */
	TOWER_SEL = "twr.sel",

    //#endregion

    

    //#region FILTERS ENTITIES

	/** CYCLE: UUID selezionato */
	CYCLE_SEL = "cycle.sel",
    /** 
     * CYCLE: lista di indici dei possibili stati del CYCLE 
     * 0: "PLANNED", 1: "RUNNING", 2: "HARVESTED", 3: "REJECTED"
    */
    CYCLE_STATUS = "cycle.status",
    
    /** TASK UUID selezionato */
    TASK_SEL = "task.sel",
	/** TASK: lo SCOPE attualmente filtrato */
	SCOPE_FIL = "scope.fil",
    /** TASK: lo GROUP dello SCOPE attualmente filtrato  */
    SCOPE_GROUP_FIL = "group.fil",

    /** PRODUCTION-REQUEST UUID selezionato */
    REQUEST_SEL = "req.sel",

    /** CROP ID selezionato */
    CROP_SEL = "crop.sel",

    /** TYPE selezionato (Attachment) */
    TYPE_SEL = "type.sel",

    /** CROP-RECIPE filtro CROP_RECIPE_VIEW */
    CROP_RECIPE_VIEW = "crop.recipe.view",
    
	/** la SEVERITY attualmente filtrata */
	ALERT_SEVERITY = "alert.svr",
	/** lo STATUS ALARMattualmente filtrata */
	ALERT_STATUS = "alert.sts",
	/** la modalità di visualizzazione */
	ALERT_MODE = "alert.mde",

    /** PRODUCTION  */
    PRODUCTION_STATE = "prod.sts",
    PRODUCTION_SEARCH = "prod.search",

    /** GROUP di METADATA */
	META_GROUP = "meta.grp",
	/** CODE SERVICE di METADATA */
	META_SERVICE = "meta.srv",
	/** CODE SERVICE di METADATA */
	META_FEATURE = "meta.feature",
    /** PROPRIETA' DA VISUALIZZARE IN TABELLA */
    META_COLS = "meta.cols",    

    //#endregion


    /** PLANNER: gruppi di colori per: "crop" / "cycle" (default)  */
    PLANNER_COLORS = "pln.clr",
    /** PLANNER: gruppi visualizzati sul PLANNER: "gus" (GROWUNIT default) / "phases" */
    PLANNER_STRUCT = "pln.str",
    /** PLANNER: a livello di sessione.
     * "def" | null: visualizza tutti i CYCLES
     * "no_prod": non visualizza i CYCLES di tipo PRODUCTION
     * */
    PLANNER_SESSION = "pln.session",
    /**
     * PLANNER: layer da visualizzare nel GANTT, se non specificato visualizza tutti i layer
     * "def" | null: visualizza tutti i LAYERS escludendo i layers DISABLED
     * "all": visualizza tutti i LAYERS anche quelli DISABLED
     */
    PLANNER_LAYER = "pln.lyr",
  

    /** MAP: layer visualizzato sulla mappa (system / alerts / sensors / nothing) */
    MAP_LAYER = "map.lyr",


    /** PIVOT GRID DATE RANGE */
    PIVOT_DATE_RANGE = "pivot.date",
    /** PIVOT GRID PRESET */
    PIVOT_PRESET = "pivot.preset",


    /** [DA NON USARE] INDICA IL RUOLO NEL PLC-PANEL*/
	ROLE = "r",
	/** [DA NON USARE] indica un numero random per poter aggiornare la stringa URL */
	UPDATE = "t",
    /** [DA NON USARE] indica un action tra diverse pagine */
    ACTION = "action",
    /** [DA NON USARE] schema del RECIPE da usare */
    SCHEMA = "schema", 

}

export enum URL_PAR_PLANNER_SESSION {
    DEFAULT = "def",
    NO_PROD = "no_prod",
}
export enum URL_PAR_PLANNER_LAYER {
    DEFAULT = "def",
    ALL = "all",
    ONLY_OCCUPIED = "only_occupied",
}